/* import __COLOCATED_TEMPLATE__ from './collapsible-toggle.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { action } from '@ember/object';
import { getAllCollapsibleSections, toggleSectionOpen } from '@intercom/embercom-prosemirror-composer/lib/helpers/collapsible-section';
let CollapsibleToggle = (_class = class CollapsibleToggle extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "lastHoverEventCoords", void 0);
    _defineProperty(this, "lastHoverEventNodePosition", void 0);
  }
  get composer() {
    return this.args.composer;
  }
  get isHoveringCollapsible() {
    let hoveredElement = this.composer.state.hoverInfo?.hoveredElement;
    let hoveredNode = hoveredElement && this.composer.state.resolveNode(hoveredElement);
    return hoveredNode?.type.name === 'collapsibleSectionSummary';
  }
  getCollapsibleSectionPosition() {
    let summaryElement = this.composer.state.hoverInfo?.hoveredElement;
    let detailElement = summaryElement?.parentElement;
    let collapsibleSectionNode = detailElement && this.composer.state.resolveNode(detailElement);
    let nodeWithPos = collapsibleSectionNode && getAllCollapsibleSections(this.composer.state.prosemirrorState).find(child => child.node === collapsibleSectionNode);
    return nodeWithPos?.pos;
  }
  get collapsibleSectionPosition() {
    let isHoveringSameElement = this.lastHoverEventCoords === this.composer.state.hoverInfo?.clientCoords;
    if (!isHoveringSameElement) {
      this.lastHoverEventNodePosition = this.getCollapsibleSectionPosition();
      this.lastHoverEventCoords = this.composer.state.hoverInfo?.clientCoords;
    }
    return this.lastHoverEventNodePosition;
  }
  toggleOpen() {
    let hoveredCollapsibleSectionWithPos = getAllCollapsibleSections(this.composer.state.prosemirrorState).find(child => child.pos === this.collapsibleSectionPosition);
    if (hoveredCollapsibleSectionWithPos) {
      toggleSectionOpen(this.composer, hoveredCollapsibleSectionWithPos);
    }
  }
  get computedStyle() {
    let hoveredElement = this.composer.state.hoverInfo.hoveredElement;
    if (!hoveredElement) {
      return '';
    }
    let offset = this.calculateOffset(hoveredElement); // Positions the button over the collapsible chevron
    let left = offset.x;
    let top = offset.y;
    return sanitizeHtml(`
      left: ${left}px;
      top: ${top}px;
      `);
  }
  calculateOffset(domElement) {
    let x = 0;
    let y = 0;
    while (!domElement.classList.contains('embercom-prosemirror-composer')) {
      x += domElement.offsetLeft;
      y += domElement.offsetTop;
      let computedStyles = getComputedStyle(domElement);
      let borderLeftWidth = Number.parseInt(computedStyles.getPropertyValue('border-left-width').replace('px', ''), 10);
      let borderTopWidth = Number.parseInt(computedStyles.getPropertyValue('border-top-width').replace('px', ''), 10);
      x += borderLeftWidth;
      y += borderTopWidth;
      domElement = domElement.offsetParent;
    }
    return new DOMRect(x, y, 0, 0);
  }
}, _applyDecoratedDescriptor(_class.prototype, "toggleOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleOpen"), _class.prototype), _class);
export { CollapsibleToggle as default };